import React from 'react';
import Conditional from '../../common/conditional';

import { concatClassNames } from '../../../utils/utilities';
import classNames from './style.module.scss';

interface OverviewProps {
	iconName: string;
	title: string;
	subtitle: string;
	onClick?: () => void;
}

const Overview: React.FC<OverviewProps> = ({
	iconName,
	title,
	subtitle,
	onClick,
}) => {
	return (
		<div className={classNames.overview}>
			<div className={classNames.overviewIcon}>
				<i className={concatClassNames(['bi', iconName])}></i>
			</div>

			<div className={classNames.overviewBody}>
				<h3>{title}</h3>
				<p>{subtitle}</p>
			</div>

			<Conditional isVisible={!!onClick}>
				<button onClick={onClick}>
					<i className="bi bi-chevron-right"></i>
				</button>
			</Conditional>
		</div>
	);
};

export default Overview;
